import styled from 'styled-components';

export const StyledGoogleAccessTokenProfile = styled.div`
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;
